import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { SingleItem, ManyItem } from "types/interfaces";
import singleProduct from "data/empty/singleProduct.json";
import { ResponseContext } from "types/responses";
import { RentripsURL } from "utils/request";

export const useSearch = (query: string): [ManyItem[], boolean, boolean] => {
	const [result, setResult] = useState<ManyItem[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);

	const getData = useCallback(async () => {
		try {
			setLoading(true);

			const { data } = await axios.get(`${RentripsURL}/api/product?${query}`, {
				headers: { "Access-Control-Allow-Origin": "*" },
			});
			setTimeout(() => {
				setLoading(false);
				if (Array.isArray(data)) setResult(data);
			}, 500);
		} catch (error) {
			setLoading(false);
			setError(true);
		}
	}, [query]);

	useEffect(() => {
		getData();
	}, [getData]);

	return [result, loading, error];
};

export const useSingle = (id: string) => {
	const [result, setResult] = useState<SingleItem>(singleProduct);

	const getData = async () => {
		const { data } = await axios.get(RentripsURL + `/api/product/${id}`, {
			headers: { "Access-Control-Allow-Origin": "*" },
		});
		if (data) {
			setTimeout(() => {
				setResult(data);
			}, 1000);
		}
	};

	useEffect(() => {
		getData();
	}, [id]);

	return result;
};

export const useFetch = <T = {}>(url: string, defaultValue?: T) => {
	const [data, setData] = useState<T>(defaultValue as unknown as T);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const fetchData = useCallback(async () => {
		setLoading(true);
		try {
			const { data }: { data: ResponseContext<T> } = await axios.get(url, {
				headers: { "Access-Control-Allow-Origin": "*" },
			});
			setData(data.data);
		} catch (error) {
			setError(error as string);
		}
		setLoading(false);
	}, [url]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	return { data, loading, error };
};
